<script setup lang="ts">
import { ref } from 'vue'
import { useDark, useToggle } from '@vueuse/core'

import { DropdownActionsData } from '@types'

import { useUser } from '../utils/useUser'

import SubscriptionPlan from './SubscriptionPlan.vue'
import User from './User.vue'

import { DSSwitch } from '@ds'
import { MoonIcon } from '@lucide/vue'

const emit = defineEmits<{
  (e: 'click:item'): void
}>()

const appVersion = `${__APP_VERSION__ || ''}`

const { menuItems } = useUser()

const expanded = ref(false)

const isDark = useDark()
const toggleDark = useToggle(isDark)

const closeMenu = () => {
  expanded.value = false
}

const handleSelect = (item: DropdownActionsData) => {
  item.action?.(closeMenu)
  emit('click:item')
}
</script>

<template>
  <div class="flex flex-col gap-0.5">
    <User
      is-mobile
      :expanded
      @click="expanded = !expanded"
    />
    <div
      v-if="expanded"
      class="flex flex-col gap-0.5 pt-1"
    >
      <SubscriptionPlan
        is-mobile
        @click:item="emit('click:item')"
      />
      <label class="flex items-center gap-3 h-11 px-3 rounded-ds-sm text-[15px] font-medium text-primary-foreground/85 hover:bg-white/10 cursor-pointer">
        <MoonIcon
          class="size-4.5 text-primary-foreground/60 shrink-0"
          aria-hidden="true"
        />
        <span class="flex-1">Dark theme</span>
        <DSSwitch
          :model-value="isDark"
          @update:model-value="toggleDark"
        />
      </label>
      <button
        v-for="item in menuItems"
        :key="item.value ?? item.label"
        type="button"
        class="flex items-center gap-3 h-11 px-3 rounded-ds-sm text-[15px] font-medium text-primary-foreground/85 hover:bg-white/10 cursor-pointer"
        :disabled="item.disabled"
        @click="handleSelect(item)"
      >
        <component
          :is="item.icon"
          v-if="item.icon"
          class="size-4.5 shrink-0"
          aria-hidden="true"
        />
        <span class="flex-1 text-left">{{ item.label }}</span>
      </button>
      <div
        v-if="appVersion"
        class="px-3 pt-4 text-xs font-medium text-white/50"
      >
        Version {{ appVersion }}
      </div>
    </div>
  </div>
</template>
